import React from "react";
import { Box, styled, Typography, useTheme } from "@mui/material";
import { CenteredSiteBlock } from "../../routes/Home";
import BookCard from "./BookCard";

const Container = styled(Box)(({ theme, backgroundImage }) => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    width: "100%",
    minHeight: "100px",
    backgroundColor: theme.palette.blackPro,
    paddingTop: theme.spacing(7),
    paddingBottom: theme.spacing(7),
    position: "relative",
  };
});

const BooksContent = ({ podcast }) => {
  const theme = useTheme();

  const livres = React.useMemo(() => {
    let tmp = null;
    try {
      tmp = JSON.parse(podcast.jsonLivres);
    } catch (e) {
      console.error("Error with the livres...");
    }
    return tmp;
  }, [podcast]);

  return (
    <Container>
      <CenteredSiteBlock
        sx={{
          alignItems: "flex-start",
          flexDirection: "column",
          paddingRight: 2,
          paddingLeft: 2,
        }}
      >
        <Typography
          sx={{
            fontFamily: "Branding Bold",
            fontWeight: "700",
            fontSize: 23,
            color: "white",
            marginBottom: 3,
          }}
        >
          Livres{" "}
          <span
            style={{
              color: theme.palette.primary.main,
            }}
          >
            connexes
          </span>
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            gap: 7,
          }}
        >
          {livres
            ?.filter((e, i) => i < 4)
            ?.map((book) => {
              return (
                <BookCard
                  key={book.id}
                  book={book}
                  sx={{
                    minWidth: "250px",
                  }}
                />
              );
            })}
        </Box>
      </CenteredSiteBlock>
    </Container>
  );
};

export default BooksContent;
